import React from 'react';
import PhoneInput from 'react-phone-number-input';
import './MuiPhoneInput.scss';

export default function MuiPhoneInput(props) {
  return (
    <div className="phone-input-container">
      <PhoneInput {...props} />
    </div>
  );
}
